var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 824,
    height: 811,
    viewBox: "0 0 824 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_42_1701)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 412,
    cy: 405.5,
    rx: 162,
    ry: 155.5,
    fill: "url(#paint0_linear_42_1701)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_42_1701",
    x: 0,
    y: 0,
    width: 824,
    height: 811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_42_1701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1701",
    x1: 269.154,
    y1: 561,
    x2: 612.754,
    y2: 511.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD1D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow2);
export default __webpack_public_path__ + "static/media/shadow-2.ff376beda51495ec64fadd2391582de5.svg";
export { ForwardRef as ReactComponent };